import React from 'react';
import Layout from '../Layout';
// 1. Theme loader imports
import { useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '../../assets/theme/GlobalStyles';
import {useTheme} from '../../hooks/useTheme';
import WebFont from 'webfontloader';
import Themepicker from './Themepicker';
// import './index.scss';
// 2: Create a cotainer
const Container = styled.div`
  display: block;
  position: relative;
`;

const Theme = () => {
  // 3: Get the selected theme, font list, etc.
  const {theme, themeLoaded, getFonts} = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(theme);

  useEffect(() => {
    setSelectedTheme(theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [themeLoaded]);

  // 4: Load all the fonts
  useEffect(() => {
    WebFont.load({
      google: {
        families: getFonts()
      }
    });
  });
  return (
    <div>
    {themeLoaded && <ThemeProvider theme={selectedTheme} className="theme-container">
      <GlobalStyles/>
      <Layout/>
      <Container className='theme-container'>
        <Themepicker setter={setSelectedTheme} />
      </Container>    
      
  </ThemeProvider>}
  </div>
  )
}

export default Theme